import { useEffect } from "react";
import Navbar from "../components/Navbar";
import HeroSection from "../components/HeroSection";
import SupplierMarquee from "../components/SupplierMarquee";
import ProcessSection from "../components/ProcessSection";
import RateImpactCalculator from "../components/RateImpactCalculator";
import SavingsCases from "../components/SavingsCases";
import StateMap from "../components/StateMap";
import RateComparison from "../components/RateComparison";
import LeadForm from "../components/LeadForm";
import FaqSection from "../components/FaqSection";
import Footer from "../components/Footer";

export default function HomePage() {
  useEffect(() => {
    if (window.location.hash) {
      const el = document.getElementById(window.location.hash.slice(1));
      if (el) setTimeout(() => el.scrollIntoView({ behavior: "smooth" }), 100);
    } else {
      window.scrollTo(0, 0);
    }
  }, []);

  return (
    <>
      <Navbar />
      <main>
        <HeroSection />
        <ProcessSection />
        <RateImpactCalculator />
        <StateMap />
        <RateComparison />
        <LeadForm />
        <FaqSection />
      </main>
      <Footer />
    </>
  );
}
